import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { CardService } from 'src/app/services/card/card.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DeviceService } from 'src/app/services/device/device.service';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { ModernPreloadService } from 'src/app/services/modern-preload/modern-preload.service';
import { AppNotification } from 'src/app/data-models/common/app-notification.model';
import { NetworkStatus } from 'src/app/enums/network-status.enum';
import { MatMenu } from '@lenovo/material/menu';
import { IMenuItem } from 'src/app/services/config/menu-item.interface';

@Component({
	selector: 'vtr-material-hamburger-menu',
	templateUrl: './material-hamburger-menu.component.html',
	styleUrls: ['./material-hamburger-menu.component.scss'],
	exportAs: 'materialHamburgerMenuComponent'
})
export class MaterialHamburgerMenuComponent implements OnInit, OnDestroy {
	@ViewChild(MatMenu, {static: true}) matMenu: MatMenu;
	@Input() items: IMenuItem[];
	@Input() currentRoutePath: string;
	isLoggingOut = false;
	private subscription: Subscription;
	constructor(
		public deviceService: DeviceService,
		public languageService: LanguageService,
		public commonService: CommonService,
		public modernPreloadService: ModernPreloadService,
		private cardService: CardService,
		private dialogService: DialogService,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.subscription = this.commonService.notification.subscribe((notification: AppNotification) => {
			this.onNotification(notification);
		});
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	private onNotification(notification: AppNotification) {
		if (notification) {
			switch (notification.type) {
				case NetworkStatus.Online:
					this.modernPreloadService.getIsEntitled();
					break;
				default:
					break;
			}
		}
	}

	public hasSecondaryMenu(item: IMenuItem) {
		if (Array.isArray(item?.subitems)) {
			for (const element of item.subitems) {
				if (Array.isArray(element?.subitems) && !element.hide && element.subitems.some((it) => !it.hide)) {
					return true;
				}
			}
		}
		return false;
	}

	public openExternalLink(link) {
		if (link) {
			window.open(link);
		}
	}

	onMenuItemClick(item, event?) {
		window.getSelection().empty();

		if (item.outletLink)
		{
			return;
		}

		if(item.path)
		{
			this.router.navigateByUrl(item.path);
		}
	}

	menuItemKeyDown(path, subpath?, secondaryPath?) {
		secondaryPath ? this.router.navigateByUrl(`/${path}/${subpath}/${secondaryPath}`)
			: subpath ? this.router.navigateByUrl(`/${path}/${subpath}`)
			: path ? this.router.navigateByUrl(`/${path}`) : this.router.navigateByUrl(`/`);
	}

	openModernPreloadModal() {
		this.dialogService.openModernPreloadModal();
	}

	updateActiveItem(id: string): boolean {
		if (id === 'security') {
			return this.currentRoutePath === '/home-security' || this.currentRoutePath?.startsWith('/security');
		}
		if (id === 'support') {
			return this.currentRoutePath === '/hardware-scan' || this.currentRoutePath?.startsWith('/support');
		}
		return false;
	}
}
